import React from 'react';
import styled from 'styled-components';
import Header from '../cabecalho/Cabecalho';
import Menu from '../menu/Menu';

const Container = styled.div`
  margin-left: 200px; /* leave space for the fixed menu */
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
  color: #58585B;
`;

const Title = styled.h1`
  font-size: 48px;
  margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
`;

const NotFound = () => (
  <>
    <Header />
    <Menu />
    <Container>
      <Title>404</Title>
      <Subtitle>Página não encontrada</Subtitle>
    </Container>
  </>
);

export default NotFound;
